import {DossierStoreProductsType} from '@/stores/store-and-terminals'

export const CRYPTO_KEY = '$g,~rb%[mS:H2meE'
export const PRODUCTS_KEY = 'products'

export const noProductsAccess: DossierStoreProductsType = {
    amex: false,
    moto: false
}
